<template>

    <div class="flex flex-col items-stretch min-h-screen max-h-screen bg-black">
        <!-- select-none -->

        <navbar type="skinny"></navbar>

        <div class="flex flex-1">
            <div class="flex items-stretch min-h-full min-w-full">
                <div class="w-auto max-w-20rem lg:flex-1 lg:w-auto bg-black text-white relative flex-col overflow-y-auto select-none ml:0 lg:ml-4 lg:pr-2" style="max-height: calc(100vh - 58px)">

                    <div class="w-full">

                        <div class="uppercase text-grey-darkest mb-2 hidden lg:block">Recommended Chasers</div>

                        <!-- Followed Chasers -->
                        <router-link 
                            :to="{ name: 'ChasersProfile', params: { profile: parseChannelId(user.name) }}"
                            class="w-full flex flex-1 px-3 py-1 relative items-center cursor-pointer no-underline hover:bg-grey-darkest rounded-0 lg:rounded-lg lg:p-2 lg:mb-1"
                            v-for="user in recommended"
                            v-bind:key="user.id"
                        >
                            <div class="mx-auto lg:mx-0 m-2 lg:m-0 relative">
                                <gravatar :hash="user.gravatar_hash" class="h-10 w-10 rounded-full mx-auto"></gravatar>
                                <div class="absolute pin-t pin-r block lg:hidden">
                                    <div class="w-5 h-5 bg-grey rounded-full border-black border-2 -mr-1 -mt-1" v-if="!user.is_active"></div>
                                </div>
                            </div>
                            
                            <div class="hidden lg:block lg:pl-2 lg:flex-1">
                                <div class="text-lg text-white">{{ user.name }}</div>
                                <div class="text-grey-darker" v-if="user.location !== undefined && user.location !== null">{{ user.location.location_text }}</div>
                                <div class="text-grey-darker" v-if="user.location == undefined || user.location == null  || user.location.location_text == null">Location Unavailable</div>
                            </div>
                            <div class="hidden lg:block lg:pr-2">
                                <div class="w-3 h-3 bg-green rounded-full" v-if="user.is_active"></div>
                                <div class="w-3 h-3 bg-grey rounded-full" v-if="!user.is_active"></div>
                            </div>
                        </router-link>


                    </div>
                </div>
                <div class="flex-1 text-white relative overflow-y-auto bg-grey-darkest rounded-0 mx-0 lg:ml-2" style="max-height: calc(100vh - 58px)">
                    <div class="w-full p-5">
                        <h2 class="text-grey-lightest">Recent Videos</h2>
                        <p class="text-grey-dark mt-1">View our chasers' most recent video from their chases. Chasers typically upload 2-3 high quality videos per chase!</p>

                        <div class="flex flex-row flex-wrap -mx-2" >
                            <div class="w-full md:w-full lg:w-1/2 px-2 cursor-pointer" v-for="video in videos" v-on:click="goToVideo(video)">
                                <div id="holder" class="h-auto">
                                    <div id="anim" class="relative">
                                        <div class="flex flex-col sm:flex-row mt-4 rounded-lg bg-white select-none">
                                            <img class="h-auto sm:h-24 rounded-t-lg sm:rounded-l-lg sm:rounded-r-none" style="object-fit: cover;" :src="thumbnailImage(video.created_at, video.upload_id)" />
                                            <div class="p-2 flex flex-col justify-between">
                                                <strong class="text-black">{{ video.title }}</strong>
                                                <p class="text-sm text-grey-dark mt-1 sm:mt-0">{{ video.user }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>        
                    </div>
                    <div class="w-full p-5">
                        <h2 class="text-grey-lightest">Chaser Spotlight</h2>
                        <p class="text-grey-dark mt-1">Learn more about certain storm chasers and view content produced by them.</p>

                        <div class="flex overflow-x-auto pt-2">
                            <div class="flex-none w-1/2 md:w-1/3 xl:w-1/5 pr-4 pb-2" v-for="chaser in recommended">
                                <ChaserCard :chaser="chaser" />
                            </div>
                        </div>        
                    </div>
                    <div class="w-full p-5">
                        <h2 class="text-grey-lightest">Networks</h2>
                        <p class="text-grey-dark mt-1">View Networks that utilize our platform. You can also see a specific network's chaser right on a map!</p>

                        <p class="pt-2">Coming soon...</p>
                    </div>

                </div>
                    
            </div>
        </div>
    </div>
</template>

<script>

    import { mapActions, mapGetters } from 'vuex';
    import { EventBus } from '@/events'
    import * as Config from '@/config'

    import moment from 'moment'

    import Modal from '@/components/Modal'
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import MapSettings from '@/components/Modals/MapSettings'
    import Navbar from '@/components/Navbar'
    import Gravatar from 'vue-gravatar';

    import LatestVideo from '@/components/LatestVideo'
    import ChaserCard from './ChaserCard'


    export default {
        name: 'Map',
        data() {
            return {
                following: {},
                checkAuth: null,
                recommended: {},
                videos: {},
                networks: {},
                selectedVideo: null
            }
        },
        mounted() {
            this.getDiscover()
        },
        components: {
            Navbar,
            Gravatar,
            Modal,
            LatestVideo,
            ChaserCard
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
                'isAuthenticated'
            ]),
            getDiscover() {
                this.$http.get(Config.apiPath + "/api/v1/discover", this.getAuthorizationHeader()).then((response) => {
                    let results = response.data
                    if(results.status == 'success') {
                        this.$set(this, 'following', response.data.following);
                        this.$set(this, 'recommended', response.data.recommended);
                        this.$set(this, 'videos', response.data.recentVideos);
                    }
                });
            },
            parseChannelId(name) {
                return (name.toLowerCase()).replace(" ", ".");
            },
            thumbnailImage(date, id) {
                var date = moment.utc(date);
                var isAfter = moment(date).isAfter('2018-05-27 00:06:00');

                if(isAfter) {
                    return 'https://media-preview.livestormsvideo.com/thumbnails/' + date.year() + "/" + (date.month() + 1) + "/" + date.date() + "/" + id + "-00001.png";
                }
                return 'https://lsm-mms.s3.amazonaws.com/thumbnails/' + date.year() + "/" + (date.month() + 1) + "/" + date.date() + "/" + id + "-1.jpg";
            },
            goToVideo(video) {
                window.open('https://youtu.be/' + video.youtube_id, '_blank');
            }
        },
        filters: {
            parseDateTimeToLocal: function(timestamp) {
                return moment.utc(timestamp).local().format('MMMM D, Y h:mm A')
            },
            parseTimeAgo: function(timestamp) {
                return moment.utc(timestamp).fromNow()
            },
            parseSecondsToTime: function(value) {
                if(value !== null) {
                    var seconds = Math.floor( value % 60 ).toString();
                    var minutes = Math.floor( value / 60 ).toString();
                    if( seconds.length === 1 ){
                        seconds = '0' + seconds;
                    }
                    return minutes + ':' + seconds;
                }
            }
        }
    }

</script>

<style>

    #holder:active #anim {
        transform: scale(0.97)
    }

    .bg_icon {
        font-size: 110px;
        -webkit-transform: rotate(20deg);
        transform: rotate(20deg);
        right: -30px;
        top: -20px;
        opacity: .1;
    }

    .img-responsive-16by9 {
        display: block;
        height: 0;
        padding-bottom: 56.25%;
        overflow: hidden;
    }

    .max-w-20rem {
        max-width: 20rem;
    }

</style>
